import React from "react";
import AuthCard from "../../shared/components/CustomCards";
import PrimaryButton from "../../shared/components/CustomButtons";
import PasswordReset from "../../assets/images/passwordreset.svg";
import { useNavigate } from "react-router-dom";

export default function RegisterSuccess() {
  const navigate = useNavigate();

  return (
    <div className="flex justify-content-center align-items-center h-full">
      <AuthCard>
        <img src={PasswordReset} alt="" className="m-auto block" />
        <p className="text-3xl heading font-medium text-center rubik">
          Account created successfully
        </p>
        <p className="text-center">Now, you can log in to your account </p>
        <PrimaryButton
          label="Back to login"
          extraClassNames="mt-3"
          onClick={() => navigate("/auth/login")}
        />
      </AuthCard>
    </div>
  );
}
